/**
 * Kids store taxonomy — mirrors application/models/kids/categories.py
 */

export const KIDS_STAGE_EARLY = 1;
export const KIDS_STAGE_STRUCTURED = 2;
export const KIDS_STAGE_ADVANCED = 3;

export const KIDS_STAGES = [
  { stage: KIDS_STAGE_EARLY, label: "Early Movement & Motor Skills" },
  { stage: KIDS_STAGE_STRUCTURED, label: "Structured Play & Basic Sports" },
  { stage: KIDS_STAGE_ADVANCED, label: "Advanced Play & Training" },
];

export const KIDS_SPORTS = [
  { sport: 301, label: "Football" },
  { sport: 302, label: "Basketball" },
  { sport: 303, label: "Athletics" },
  { sport: 304, label: "Tennis" },
  { sport: 305, label: "Rugby" },
  { sport: 306, label: "Cricket" },
  { sport: 307, label: "Swimming" },
  { sport: 308, label: "Ballet" },
];

const EARLY_SUBCATEGORIES = [
  { slug: "toys-play-equipment", label: "Toys & Play Equipment" },
  { slug: "ride-ons-mobility", label: "Ride-ons & Mobility" },
  { slug: "play-surfaces", label: "Play Surfaces" },
  { slug: "apparel", label: "Apparel" },
  { slug: "footwear", label: "Footwear" },
  { slug: "protective-gear", label: "Protective Gear" },
  { slug: "care-accessories", label: "Care Accessories" },
];

const STRUCTURED_SUBCATEGORIES = [
  { slug: "sport-starter-equipment", label: "Sport Starter Equipment" },
  { slug: "outdoor-play", label: "Outdoor Play" },
  { slug: "training-gear", label: "Training Gear" },
  { slug: "balls", label: "Balls" },
  { slug: "apparel", label: "Apparel" },
  { slug: "footwear", label: "Footwear" },
  { slug: "protective-gear", label: "Protective Gear" },
];

const ADVANCED_BASE_SUBCATEGORIES = [
  { slug: "training-equipment", label: "Training Equipment" },
  { slug: "footwear", label: "Footwear" },
  { slug: "sports-gear", label: "Sports Gear" },
  { slug: "accessories", label: "Accessories" },
  { slug: "bags-trolley", label: "Bags and Trolley" },
  { slug: "apparel", label: "Apparel" },
  { slug: "safety-gear", label: "Safety Gear" },
  { slug: "balls", label: "Balls" },
];

const SPORT_SPECIFIC_SUBCATEGORIES = {
  301: [
    { slug: "team-kits", label: "Team Kits" },
    { slug: "gloves", label: "Gloves" },
  ],
  302: [{ slug: "team-kits", label: "Team Kits" }],
  305: [{ slug: "team-kits", label: "Team Kits" }],
};

/** Subcategories that may use a size field on the product row */
export const KIDS_SIZED_SUBCATEGORIES = new Set(["footwear", "apparel", "team-kits"]);

export function isAdvancedStage(stage) {
  return Number(stage) === KIDS_STAGE_ADVANCED;
}

export function subcategoriesForStage(stage, sport = null) {
  const stageVal = Number(stage);
  if (stageVal === KIDS_STAGE_EARLY) return [...EARLY_SUBCATEGORIES];
  if (stageVal === KIDS_STAGE_STRUCTURED) return [...STRUCTURED_SUBCATEGORIES];
  if (stageVal === KIDS_STAGE_ADVANCED) {
    const sportVal = sport != null ? Number(sport) : null;
    if (!sportVal) {
      return [
        ...ADVANCED_BASE_SUBCATEGORIES,
        { slug: "team-kits", label: "Team Kits" },
        { slug: "gloves", label: "Gloves" },
      ];
    }
    const extras = SPORT_SPECIFIC_SUBCATEGORIES[sportVal] || [];
    return [...ADVANCED_BASE_SUBCATEGORIES, ...extras];
  }
  return [];
}

export function stageLabel(stage) {
  const row = KIDS_STAGES.find((s) => s.stage === Number(stage));
  return row?.label || `Stage ${stage}`;
}

export function sportLabel(sport) {
  const row = KIDS_SPORTS.find((s) => s.sport === Number(sport));
  return row?.label || `Sport ${sport}`;
}

export function subcategoryNeedsSize(slug) {
  return KIDS_SIZED_SUBCATEGORIES.has(slug);
}
